import { dev } from "$app/environment"
import { APP_LOG_SENTRY } from "$lib/env"
import * as Sentry from "@sentry/sveltekit"

if (!dev && APP_LOG_SENTRY) {
  Sentry.init({
    dsn: APP_LOG_SENTRY,
  })
}

export const handleError = Sentry.handleErrorWithSentry()
